import { render, staticRenderFns } from "./work-orders-form.vue?vue&type=template&id=08286446&scoped=true"
import script from "./work-orders-form.vue?vue&type=script&lang=js"
export * from "./work-orders-form.vue?vue&type=script&lang=js"
import style0 from "./work-orders-form.vue?vue&type=style&index=0&id=08286446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08286446",
  null
  
)

export default component.exports